module.exports = __webpack_public_path__ + "img/hr-train-wheels-shadow-5.2003d050.png";